import React from 'react';
import { useParams } from 'react-router-dom';
import MySQLBanner from '../../assets/imgmysql.webp';
import python from '../../assets/python.webp';
import basicpython from '../../assets/basicpython.webp';
import cyber from '../../assets/cyber.webp';
import aws from '../../assets/aws.png';
import { FaCheckCircle } from 'react-icons/fa'; // Icons for better visualization
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Carousel styles


// this for image 

import cyber_2 from '../../assets/Certificate Course in Cyber Security banner image.png';

// Mock data for courses with additional fields
const courses = [
  {
    id: 1,
    name: 'Certificate Course in Structured Query Language using MySQL',
    description: 'Learn the fundamentals of SQL and how to manage databases effectively.',
    price: 'Free',
    category: 'SQL',
    banner: [MySQLBanner, '/images/mysql-banner-2.webp'], // Multiple banner images for carousel
    admissionStatus: 'Open',
    syllabus: [
      'Introduction to SQL',
      'Advanced SQL Queries',
      'Database Design and Normalization',
      'MySQL Database Administration',
    ],
    faq: [
      { question: 'What is SQL?', answer: 'SQL is a language used to manage and query relational databases.' },
      { question: 'What tools do I need for this course?', answer: 'You will need a MySQL database or a similar SQL setup.' },
      { question: 'How can I get certified?', answer: 'Complete the course and take the mock test to earn your certificate!' },
    ],
    instructor: {
      name: 'Dr. Jane Doe',
      bio: 'Dr. Jane Doe has over 10 years of experience in database management and SQL. She has taught hundreds of students and helped them succeed in database-related careers.',
      image: '/images/instructor.jpg', // Assuming there's an image for the instructor
    },
    reviews: [
      { name: 'Alice', rating: 5, comment: 'Amazing course! Very informative and easy to follow.' },
      { name: 'Bob', rating: 4, comment: 'Great content, but would have loved more examples.' },
    ],
    testimonials: [
      { name: 'John Doe', text: 'This course gave me a solid foundation in SQL. Highly recommend!' },
      { name: 'Jane Smith', text: 'Great course with practical examples. It helped me advance my career.' },
    ],
    
    
  programoutcomes: [
    { name: 'Master SQL syntax and commands to handle complex database operations', id: 1 },
    { name: 'Develop expertise in designing and managing relational databases', id: 2 },
    { name: 'Gain hands-on experience through real-world database projects and case studies.', id: 3 },
    { name: 'Build advanced SQL skills to perform queries, indexing, and optimizations..', id: 4 },
    { name: 'Earn a certificate demonstrating your SQL proficiency to boost your career.', id: 5 },
  ],
  },
  // Add more courses as needed...
  {
    id: 2,
    name: 'Certificate Course in Python Programming',
    description: 'Master Python programming from basics to advanced concepts and boost your coding skills.',
    price: 'Free',
    category: 'Programming',
    banner: [python, python], // Multiple banner images for carousel
    admissionStatus: 'Open',
    syllabus: [
      'Introduction to Python and Setup',
      'Data Types, Variables, and Operators',
      'Control Structures and Loops',
      'Functions and Modules',
      'Object-Oriented Programming in Python',
      'File Handling and Exceptions',
      'Python Libraries: NumPy, Pandas, Matplotlib',
      'Project: Building a Python Application',
    ],
    faq: [
      { question: 'What is Python?', answer: 'Python is a versatile, high-level programming language widely used for web development, data analysis, AI, and more.' },
      { question: 'Do I need prior programming experience?', answer: 'No, this course is beginner-friendly and starts from the basics.' },
      { question: 'How can I get certified?', answer: 'Complete the course and score at least 95% in the final test to earn your certificate.' },
    ],
    instructor: {
      name: 'Dr. Alex Johnson',
      bio: 'Dr. Alex Johnson has over 15 years of experience in software development and Python programming. He has taught Python to thousands of students worldwide and authored several books on programming.',
      image: '/images/instructor-python.jpg', // Updated instructor image for Python
    },
    reviews: [
      { name: 'Charlie', rating: 5, comment: 'Fantastic course for beginners. The projects were very helpful!' },
      { name: 'Dana', rating: 4, comment: 'Comprehensive and well-structured, but a few more examples would be great.' },
    ],
    testimonials: [
      { name: 'Sam Wilson', text: 'Learning Python with this course was a game-changer for my career in data science!' },
      { name: 'Lisa Carter', text: 'The instructor explained complex topics in a very simple manner. Highly recommend it!' },
    ],
    relatedCourses: [
      { name: 'Data Science with Python', id: 3 },
      { name: 'Machine Learning Essentials', id: 4 },
    ],
    programoutcomes: [
      { name: 'Master Python syntax and core programming concepts', id: 1 },
      { name: 'Learn to build and debug Python programs efficiently', id: 2 },
    ],
  },
  // this for Certificate Course in Basic Python
  {
    id: 3,
    name: 'Basic Certificate Course in Basic Python',
    description: 'Take your Python skills to the next level with a focus on data analysis, machine learning, and practical Python applications for data science projects. This course will enhance your coding and problem-solving skills using Python’s powerful libraries.',
    price: 'Free',
    category: 'Programming',
    banner: [python, python], // Multiple banner images for carousel
    admissionStatus: 'Open for Enrollment',
    syllabus: [
     "Introduction to Python: Syntax, Variables, and Data Types",
      "Working with Data: Lists, Dictionaries, and Tuples",
      "Control Structures and Algorithms in Python",
      "Functions, Loops, and Recursion",
      "Object-Oriented Programming with Python",
      "File I/O and Error Handling in Python",
      "Data Analysis with Python: NumPy and Pandas",
      "Data Visualization: Matplotlib and Seaborn",
      "Introduction to Machine Learning with Scikit-Learn",
      "Building Data Science Projects with Python",
      "Capstone Project: Analyzing a Real-World Dataset",
      "Exam and Certification",
    ],
    faq: [
      { question: 'What is Python used for?', answer: 'Python is a versatile programming language used for data analysis, machine learning, artificial intelligence, web development, automation, and more.' },
      { question: 'Do I need prior programming experience?', answer: 'No, this course is beginner-friendly and starts from the basics.' },
      { question: 'How can I get certified?', answer: 'Complete the course and score at least 95% in the final test to earn your certificate.' },
    ],
    instructor: {
      name: 'Dr. Alex Johnson',
      bio: 'Dr. Alex Johnson has over 15 years of experience in software development and Python programming. He has taught Python to thousands of students worldwide and authored several books on programming.',
      image: '/images/instructor-python.jpg', // Updated instructor image for Python
    },
    reviews: [
      { name: 'Charlie', rating: 5, comment: 'Fantastic course for beginners. The projects were very helpful!' },
      { name: 'Dana', rating: 4, comment: 'Comprehensive and well-structured, but a few more examples would be great.' },
    ],
    testimonials: [
      { name: 'Sam Wilson', text: 'Learning Python with this course was a game-changer for my career in data science!' },
      { name: 'Lisa Carter', text: 'The instructor explained complex topics in a very simple manner. Highly recommend it!' },
    ],
    relatedCourses: [
      { name: 'Data Science with Python', id: 3 },
      { name: 'Machine Learning Essentials', id: 4 },
    ],
    programoutcomes: [
      { name: 'Master Python syntax and core programming concepts', id: 1 },
      { name: 'Learn to build and debug Python programs efficiently', id: 2 },
    ],
  },

  // this for Advanced Program in Cyber Security

  {
    "id": 4,
    "name": "Advanced Program in Cyber Security",
    "description": "This advanced course will deepen your understanding of cyber security, covering key areas such as ethical hacking, network security, cryptography, and incident response. Gain hands-on experience with advanced techniques to protect systems from cyber threats and vulnerabilities.",
    "price": "₹108 + GST",
    "category": "Cyber Security",
    "banner": [cyber, cyber_2], // Multiple banner images for carousel
    "admissionStatus": "Open for Enrollment",
    "syllabus": [
      "Introduction to Cyber Security: Basics and Concepts",
      "Ethical Hacking: Penetration Testing and Vulnerability Assessment",
      "Network Security: Firewalls, VPNs, and Intrusion Detection Systems",
      "Cryptography and Secure Communication",
      "Cyber Threats and Mitigation Strategies",
      "Web Application Security",
      "Malware Analysis and Forensics",
      "Security Operations and Incident Response",
      "Cyber Security Laws and Regulations",
      "Cloud Security: Securing Cloud Environments",
      "Capstone Project: Securing a Real-World Network",
      "Exam and Certification"
    ],
    "faq": [
      { "question": "What is the prerequisite for this course?", "answer": "A basic understanding of networking and IT concepts is recommended, but not required." },
      { "question": "How can I get certified?", "answer": "Complete the course and score at least 95% in the final test to earn your certificate." },
      { "question": "What job roles can I pursue after this course?", "answer": "You can pursue roles such as Security Analyst, Ethical Hacker, Penetration Tester, or Cyber Security Consultant." }
    ],
    "instructor": {
      "name": "Dr. Sarah Williams",
      "bio": "Dr. Sarah Williams is an expert in cyber security with over 10 years of experience in protecting large organizations from cyber threats. She has worked as a consultant for leading firms and is passionate about educating the next generation of cyber security professionals.",
      "image": "/images/instructor-cyber-security.jpg" // Updated instructor image for Cyber Security
    },
    "reviews": [
      { "name": "John", "rating": 5, "comment": "An exceptional course! The hands-on labs were crucial in understanding real-world security challenges." },
      { "name": "Emily", "rating": 4, "comment": "Detailed and informative, but I would have liked more coverage on cloud security." }
    ],
    "testimonials": [
      { "name": "Michael Smith", "text": "This course prepared me for a career in cyber security. I now feel confident handling complex security challenges." },
      { "name": "Rachel Green", "text": "Dr. Williams’ teaching style is fantastic! She makes complex topics understandable and engaging." }
    ],
    "relatedCourses": [
      { "name": "Certified Ethical Hacker (CEH)", "id": 4 },
      { "name": "Introduction to Network Security", "id": 5 }
    ],
    "programoutcomes": [
      { "name": "Master ethical hacking and penetration testing techniques", "id": 1 },
      { "name": "Develop expertise in network security and secure communication", "id": 2 }
    ]
  },

  // this for Certificate Course in Linux Server Administration

  {
    "id": 5,
    "name": "Certificate Course in Linux Server Administration",
    "description": "This course will provide you with the essential skills needed to configure, manage, and troubleshoot Linux servers. Learn about system installation, network configuration, security practices, and server management to become proficient in Linux server administration.",
    "price": "₹108 + GST",
    "category": "System Administration",
    "banner": ["linux-server", "linux-server-banner"], // Multiple banner images for carousel
    "admissionStatus": "Open for Enrollment",
    "syllabus": [
      "Introduction to Linux: Installing and Configuring Linux Servers",
      "Linux File System: Structure and Management",
      "User and Group Management in Linux",
      "Package Management: Installing, Removing, and Updating Software",
      "Network Configuration and Troubleshooting in Linux",
      "Linux Security: User Permissions, SELinux, and Firewalls",
      "System Monitoring and Performance Tuning",
      "Remote Access and Server Administration via SSH",
      "Backup and Recovery Techniques in Linux",
      "Linux Web Servers: Apache and Nginx Configuration",
      "Introduction to Virtualization with Linux",
      "Capstone Project: Setting Up a Complete Linux Server Environment",
      "Exam and Certification"
    ],
    "faq": [
      { "question": "Do I need prior experience with Linux?", "answer": "No, this course is beginner-friendly and starts with the basics of Linux." },
      { "question": "How can I get certified?", "answer": "Complete the course and score at least 95% in the final test to earn your certificate." },
      { "question": "What kind of job can I get after completing this course?", "answer": "You can work as a Linux System Administrator, IT Support Specialist, or DevOps Engineer." }
    ],
    "instructor": {
      "name": "Mr. David Lee",
      "bio": "Mr. David Lee is a seasoned Linux Administrator with over 12 years of experience in managing large-scale Linux systems. He has worked with numerous organizations to optimize their server environments and ensure smooth system operations.",
      "image": "/images/instructor-linux.jpg" // Updated instructor image for Linux Server Administration
    },
    "reviews": [
      { "name": "Sam", "rating": 5, "comment": "Fantastic course! It covered everything I needed to know to manage Linux servers efficiently." },
      { "name": "Ashley", "rating": 4, "comment": "Great content and hands-on labs, but more in-depth coverage on network security would be helpful." }
    ],
    "testimonials": [
      { "name": "John Doe", "text": "This course gave me the confidence I needed to manage Linux servers in a professional setting." },
      { "name": "Emily Brown", "text": "Mr. Lee’s clear explanations and practical examples made complex topics easy to understand. Highly recommended!" }
    ],
    "relatedCourses": [
      { "name": "Certified Red Hat System Administrator", "id": 5 },
      { "name": "Introduction to Cloud Infrastructure", "id": 6 }
    ],
    "programoutcomes": [
      { "name": "Become proficient in Linux server installation and configuration", "id": 1 },
      { "name": "Master Linux security, networking, and performance optimization", "id": 2 }
    ]
  },

  // this for Certificate Course in Cyber Security

  {
    "id": 6,
    "name": "Certificate Course in Cyber Security",
    "description": "This course provides a comprehensive introduction to the field of cyber security. Learn about common cyber threats, security tools, risk management, ethical hacking, and best practices to protect systems and data from cyber-attacks.",
    "price": "₹108 + GST",
    "category": "Cyber Security",
    "banner": ["cyber-security-banner", "cyber-security-tools"], // Multiple banner images for carousel
    "admissionStatus": "Open for Enrollment",
    "syllabus": [
      "Introduction to Cyber Security: Key Concepts and Terminology",
      "Understanding Cyber Threats and Vulnerabilities",
      "Network Security: Firewalls, VPNs, and IDS",
      "Cryptography and Encryption Techniques",
      "Ethical Hacking: Penetration Testing and Vulnerability Assessment",
      "Risk Management and Security Policies",
      "Security Operations and Incident Response",
      "Cyber Security Tools and Techniques: SIEM, IDS/IPS",
      "Malware Analysis and Prevention",
      "Security in the Cloud: Protecting Cloud-based Infrastructure",
      "Introduction to Cyber Security Laws and Regulations",
      "Capstone Project: Simulating a Cyber Attack and Response",
      "Exam and Certification"
    ],
    "faq": [
      { "question": "Do I need prior knowledge of IT or networking?", "answer": "No, this course is designed for beginners, though basic computer skills are helpful." },
      { "question": "How can I get certified?", "answer": "Complete the course and achieve at least 95% in the final exam to earn your certificate." },
      { "question": "What career opportunities can I pursue after this course?", "answer": "You can pursue roles such as Cyber Security Analyst, Security Consultant, Ethical Hacker, or Information Security Officer." }
    ],
    "instructor": {
      "name": "Mr. James Anderson",
      "bio": "Mr. James Anderson is a leading expert in cyber security with over 15 years of experience in defending organizations from cyber threats. He has worked on numerous high-profile cyber security projects and is passionate about educating others to secure the digital world.",
      "image": "/images/instructor-cyber-security.jpg" // Updated instructor image for Cyber Security
    },
    "reviews": [
      { "name": "Jack", "rating": 5, "comment": "This course was fantastic! It helped me understand key concepts and gave me practical skills in cyber security." },
      { "name": "Sophia", "rating": 4, "comment": "Great course with a lot of valuable information. Would have liked a deeper dive into malware analysis." }
    ],
    "testimonials": [
      { "name": "Daniel Green", "text": "The best introduction to cyber security. I feel prepared to take on cyber threats and protect systems effectively." },
      { "name": "Linda Garcia", "text": "Mr. Anderson made the complex topics easy to understand. Highly recommend this course for anyone starting in cyber security!" }
    ],
    "relatedCourses": [
      { "name": "Advanced Program in Cyber Security", "id": 3 },
      { "name": "Certified Ethical Hacker (CEH)", "id": 4 }
    ],
    "programoutcomes": [
      { "name": "Master fundamental cyber security concepts and risk management", "id": 1 },
      { "name": "Learn ethical hacking techniques and how to protect against cyber threats", "id": 2 }
    ]
  }
  ,

  // this for AWS Certification Course

  {
    "id": 7,
    "name": "AWS Certification Course",
    "description": "This course is designed to prepare you for the AWS Certified Solutions Architect – Associate exam. Gain hands-on experience with AWS services and architectures, learn cloud best practices, and master the skills needed to design and deploy scalable systems on Amazon Web Services.",
    "price": "₹108 + GST",
    "category": "Cloud Computing",
    "banner": ["aws-certification", "aws-cloud"], // Multiple banner images for carousel
    "admissionStatus": "Open for Enrollment",
    "syllabus": [
      "Introduction to Cloud Computing and AWS",
      "Overview of AWS Services: Compute, Storage, Databases, and Networking",
      "Architecting on AWS: Best Practices for Scalability and Reliability",
      "AWS Identity and Access Management (IAM)",
      "Designing Highly Available and Fault-Tolerant Systems",
      "AWS Security Best Practices and Compliance",
      "Networking in AWS: VPC, Subnets, Security Groups",
      "Monitoring and Logging in AWS: CloudWatch and CloudTrail",
      "Cost and Performance Optimization in AWS",
      "Deploying and Managing Applications on AWS",
      "Preparing for the AWS Certified Solutions Architect – Associate Exam",
      "Capstone Project: Designing a Scalable Solution on AWS",
      "Exam and Certification"
    ],
    "faq": [
      { "question": "Do I need prior experience with cloud computing?", "answer": "No, this course is beginner-friendly and will cover all the necessary concepts from scratch." },
      { "question": "How can I get certified?", "answer": "Complete the course and score at least 95% in the final exam to earn your certificate." },
      { "question": "What job roles can I pursue after this course?", "answer": "After completing the course, you can pursue roles such as Cloud Architect, Solutions Architect, Cloud Consultant, or DevOps Engineer." }
    ],
    "instructor": {
      "name": "Mr. William Turner",
      "bio": "Mr. William Turner is an AWS-certified Solutions Architect with over 10 years of experience in cloud computing. He has helped organizations migrate to the cloud and optimize their AWS environments. He is passionate about helping others master cloud technologies.",
      "image": "/images/instructor-aws.jpg" // Updated instructor image for AWS Certification Course
    },
    "reviews": [
      { "name": "Ravi", "rating": 5, "comment": "Excellent course! The hands-on labs and real-world examples helped me understand how AWS works in practice." },
      { "name": "Priya", "rating": 4, "comment": "Great content, but more emphasis on exam preparation would be helpful." }
    ],
    "testimonials": [
      { "name": "Michael Davis", "text": "This course gave me the skills and confidence to pass the AWS Certified Solutions Architect exam on my first attempt!" },
      { "name": "Sarah Lee", "text": "William’s explanations were clear and practical. I now feel ready to design scalable solutions on AWS." }
    ],
    "relatedCourses": [
      { "name": "Advanced AWS Solutions Architect", "id": 7 },
      { "name": "Introduction to Cloud Computing", "id": 8 }
    ],
    "programoutcomes": [
      { "name": "Master AWS services and architectures for building scalable systems", "id": 1 },
      { "name": "Gain hands-on experience with deploying, monitoring, and managing applications on AWS", "id": 2 }
    ]
  },

  // this for HTML Certification Course

  {
    "id": 8,
    "name": "HTML Certification Course",
    "description": "This comprehensive HTML course will teach you the core principles of web development, starting with HTML5. Learn how to structure web pages, implement responsive design, and create accessible websites with practical exercises and real-world projects.",
    "price": "₹108 + GST",
    "category": "Web Development",
    "banner": ["html-course", "html-banner"], // Multiple banner images for carousel
    "admissionStatus": "Open for Enrollment",
    "syllabus": [
      "Introduction to HTML: Structure and Syntax",
      "HTML Elements: Tags, Attributes, and Properties",
      "Working with Text: Headings, Paragraphs, and Links",
      "Lists, Tables, and Forms in HTML",
      "Images, Audio, and Video Embedding",
      "HTML5 Features: New Elements and APIs",
      "Creating Responsive Layouts with HTML",
      "Web Accessibility: Best Practices for Inclusive Design",
      "SEO Basics: Structuring HTML for Search Engines",
      "Web Development Tools and Resources",
      "Capstone Project: Building a Personal Web Page",
      "Exam and Certification"
    ],
    "faq": [
      { "question": "Do I need prior web development experience?", "answer": "No, this course is beginner-friendly and assumes no prior experience." },
      { "question": "What software will I need?", "answer": "You will need a text editor (e.g., Visual Studio Code) and a modern web browser to practice HTML." },
      { "question": "How can I get certified?", "answer": "Complete the course and score at least 95% in the final exam to earn your certificate." }
    ],
    "instructor": {
      "name": "John Doe",
      "bio": "John Doe is a seasoned web developer with over 10 years of experience in front-end development. He specializes in HTML, CSS, and JavaScript and has helped countless students launch their careers in web development.",
      "image": "/images/instructor-html.jpg" // Updated instructor image for HTML
    },
    "reviews": [
      { "name": "Anna", "rating": 5, "comment": "This course helped me get started with web development! The lessons were clear, and I now feel confident building my own websites." },
      { "name": "Mark", "rating": 4, "comment": "The course is very informative, though I would have liked more advanced topics towards the end." }
    ],
    "testimonials": [
      { "name": "Sara Lee", "text": "This HTML course was exactly what I needed to kickstart my career as a web developer. Highly recommended!" },
      { "name": "David Brooks", "text": "The projects and quizzes kept me engaged, and the instructor's explanations made learning easy and fun." }
    ],
    "relatedCourses": [
      { "name": "CSS Certification Course", "id": 4 },
      { "name": "JavaScript Fundamentals", "id": 5 }
    ],
    "programoutcomes": [
      { "name": "Gain a solid understanding of HTML5 structure and syntax", "id": 1 },
      { "name": "Learn how to create accessible and responsive web pages", "id": 2 }
    ]
  },

//  /this for Javascript Certification Course

{
  "id": 9,
  "name": "JavaScript Certification Course",
  "description": "This course is designed to help you master JavaScript, from the basics to advanced concepts. Learn how to create interactive websites, work with DOM manipulation, handle asynchronous programming, and build modern JavaScript applications.",
  "price": "₹108 + GST",
  "category": "Web Development",
  "banner": ["javascript-course", "javascript-banner"], // Multiple banner images for carousel
  "admissionStatus": "Open for Enrollment",
  "syllabus": [
    "Introduction to JavaScript: Syntax, Variables, and Data Types",
    "Control Structures: Loops, Conditionals, and Functions",
    "Working with Arrays and Objects in JavaScript",
    "DOM Manipulation and Event Handling",
    "Asynchronous Programming: Callbacks, Promises, and Async/Await",
    "JavaScript Error Handling and Debugging Techniques",
    "ES6 Features: Arrow Functions, Classes, and Modules",
    "Working with JSON and APIs",
    "JavaScript Frameworks: Introduction to React.js",
    "Best Practices for Writing Clean and Maintainable JavaScript Code",
    "Building Real-World JavaScript Projects",
    "Capstone Project: Building a JavaScript Application",
    "Exam and Certification"
  ],
  "faq": [
    { "question": "Do I need prior experience with programming?", "answer": "No, this course is suitable for beginners and covers all essential concepts from the ground up." },
    { "question": "How can I get certified?", "answer": "Complete the course and achieve at least 95% in the final exam to earn your certificate." },
    { "question": "What job roles can I pursue after this course?", "answer": "After completing this course, you can pursue roles such as Front-End Developer, Web Developer, or JavaScript Developer." }
  ],
  "instructor": {
    "name": "Ms. Emily Roberts",
    "bio": "Ms. Emily Roberts is an experienced web developer and JavaScript expert with over 8 years of experience in front-end and full-stack development. She has worked with top tech companies and is passionate about helping students learn modern JavaScript technologies.",
    "image": "/images/instructor-javascript.jpg" // Updated instructor image for JavaScript Certification Course
  },
  "reviews": [
    { "name": "David", "rating": 5, "comment": "Amazing course! It provided a clear understanding of JavaScript, and the projects were incredibly helpful." },
    { "name": "Jessica", "rating": 4, "comment": "A great introduction to JavaScript. I would have liked more examples of advanced JavaScript patterns." }
  ],
  "testimonials": [
    { "name": "John Smith", "text": "This course transformed my understanding of JavaScript. I feel confident building full-fledged web applications now." },
    { "name": "Lily Johnson", "text": "The content was clear and easy to follow, and the hands-on projects helped solidify my learning." }
  ],
  "relatedCourses": [
    { "name": "Advanced JavaScript Development", "id": 8 },
    { "name": "Front-End Web Development with React", "id": 9 }
  ],
  "programoutcomes": [
    { "name": "Gain proficiency in JavaScript syntax, data structures, and programming logic", "id": 1 },
    { "name": "Develop modern JavaScript applications using best practices and popular frameworks", "id": 2 }
  ]
},

// this for Basic AI Certification Course

{
  "id": 10,
  "name": "Basic AI Certification Course",
  "description": "This course offers a comprehensive introduction to the field of Artificial Intelligence (AI). Learn about machine learning, neural networks, natural language processing, and how AI is applied in real-world scenarios. Gain hands-on experience with AI models and algorithms.",
  "price": "₹108 + GST",
  "category": "Artificial Intelligence",
  "banner": ["ai-certification", "ai-models"], // Multiple banner images for carousel
  "admissionStatus": "Open for Enrollment",
  "syllabus": [
    "Introduction to Artificial Intelligence and Machine Learning",
    "Understanding Data and Preprocessing for AI Models",
    "Supervised Learning: Regression and Classification Algorithms",
    "Unsupervised Learning: Clustering and Association",
    "Introduction to Neural Networks and Deep Learning",
    "Natural Language Processing: Techniques and Applications",
    "AI in Computer Vision: Image Processing and Recognition",
    "Reinforcement Learning: Basics and Applications",
    "AI Ethics: Fairness, Bias, and Transparency",
    "Hands-on with AI Libraries: TensorFlow, Keras, and Scikit-learn",
    "Building Simple AI Models and Applications",
    "Capstone Project: Developing an AI Solution",
    "Exam and Certification"
  ],
  "faq": [
    { "question": "Do I need prior experience with programming?", "answer": "No, this course is beginner-friendly and will teach you the fundamentals of AI, starting with basic concepts." },
    { "question": "How can I get certified?", "answer": "Complete the course and score at least 95% in the final exam to earn your certificate." },
    { "question": "What careers can I pursue after this course?", "answer": "You can pursue roles such as AI Developer, Machine Learning Engineer, Data Scientist, or AI Researcher." }
  ],
  "instructor": {
    "name": "Dr. Linda Mitchell",
    "bio": "Dr. Linda Mitchell is an AI researcher with over 12 years of experience in developing AI models for various industries, including healthcare and finance. She is passionate about making AI concepts accessible to learners of all levels and has published several research papers on machine learning and neural networks.",
    "image": "/images/instructor-ai.jpg" // Updated instructor image for AI Certification Course
  },
  "reviews": [
    { "name": "Amit", "rating": 5, "comment": "This course is a fantastic introduction to AI. The concepts were explained clearly, and the hands-on projects were very insightful!" },
    { "name": "Priya", "rating": 4, "comment": "A great start to AI, but I would have loved more in-depth coverage on deep learning and reinforcement learning." }
  ],
  "testimonials": [
    { "name": "Rajesh Kumar", "text": "This course helped me understand AI from the ground up. The hands-on projects made learning very practical and engaging." },
    { "name": "Monica Patel", "text": "Dr. Mitchell's teaching was clear and well-structured. I now have a solid foundation in AI and am excited to dive deeper into machine learning." }
  ],
  "relatedCourses": [
    { "name": "Advanced AI and Machine Learning", "id": 10 },
    { "name": "Introduction to Data Science", "id": 11 }
  ],
  "programoutcomes": [
    { "name": "Understand the fundamentals of AI and machine learning algorithms", "id": 1 },
    { "name": "Gain practical experience in developing AI models and applications", "id": 2 }
  ]
},

// this for ReactJS Certification Course
{
  "id": 11,
  "name": "ReactJS Certification Course",
  "description": "This course is designed to teach you the essentials of ReactJS, a powerful JavaScript library for building user interfaces. Learn how to create dynamic, interactive web applications with React, covering key concepts like components, hooks, and state management.",
  "price": "₹108 + GST",
  "category": "Web Development",
  "banner": ["reactjs-course", "reactjs-ui"], // Multiple banner images for carousel
  "admissionStatus": "Open for Enrollment",
  "syllabus": [
    "Introduction to ReactJS: Understanding the Basics of React and JSX",
    "Setting Up React Development Environment",
    "Components and Props: Building Reusable UI Elements",
    "State and Lifecycle in React Components",
    "Handling Events in React",
    "React Hooks: useState, useEffect, and Custom Hooks",
    "React Router: Building Single-Page Applications with Routing",
    "State Management in React: Context API and Redux",
    "Fetching Data in React: Working with APIs",
    "React Performance Optimization Techniques",
    "Testing React Applications with Jest and React Testing Library",
    "Building Real-World Projects with ReactJS",
    "Capstone Project: Developing a Full-Stack Application with ReactJS",
    "Exam and Certification"
  ],
  "faq": [
    { "question": "Do I need prior experience with React or JavaScript?", "answer": "While prior experience with JavaScript is helpful, this course is suitable for beginners and will cover all the key concepts in ReactJS." },
    { "question": "How can I get certified?", "answer": "Complete the course and achieve at least 95% in the final exam to earn your certificate." },
    { "question": "What career opportunities can I pursue after this course?", "answer": "After completing this course, you can pursue roles such as Front-End Developer, ReactJS Developer, or Web Developer." }
  ],
  "instructor": {
    "name": "Mr. John Davis",
    "bio": "Mr. John Davis is an expert in front-end development and ReactJS with over 10 years of experience in building scalable web applications. He has worked with leading tech companies and has taught ReactJS to hundreds of developers across the world.",
    "image": "/images/instructor-reactjs.jpg" // Updated instructor image for ReactJS Certification Course
  },
  "reviews": [
    { "name": "Anita", "rating": 5, "comment": "A fantastic course for learning ReactJS! The examples and projects helped me understand React concepts better." },
    { "name": "Mark", "rating": 4, "comment": "Great course with clear explanations, but I would have liked more advanced examples." }
  ],
  "testimonials": [
    { "name": "Sarah Williams", "text": "This course was a game-changer for me! I feel confident in building interactive web applications using React." },
    { "name": "James Clark", "text": "Mr. Davis made ReactJS easy to understand, and the hands-on projects were really helpful in applying the concepts." }
  ],
  "relatedCourses": [
    { "name": "Advanced ReactJS Development", "id": 11 },
    { "name": "Full-Stack Web Development with ReactJS and Node.js", "id": 12 }
  ],
  "programoutcomes": [
    { "name": "Learn to build interactive web applications with ReactJS", "id": 1 },
    { "name": "Gain hands-on experience with state management, hooks, and routing in ReactJS", "id": 2 }
  ]
},

// this for NodeJS Certification Course

{
  "id": 12,
  "name": "NodeJS Certification Course",
  "description": "This course covers the fundamentals and advanced concepts of Node.js, a powerful JavaScript runtime for building scalable server-side applications. Learn how to work with Node's non-blocking I/O model, build RESTful APIs, handle asynchronous programming, and integrate with databases.",
  "price": "₹108 + GST",
  "category": "Web Development",
  "banner": ["nodejs-course", "nodejs-server"], // Multiple banner images for carousel
  "admissionStatus": "Open for Enrollment",
  "syllabus": [
    "Introduction to NodeJS: Understanding the Node.js Runtime and Ecosystem",
    "Setting Up NodeJS Development Environment",
    "Working with NodeJS Modules and npm (Node Package Manager)",
    "Creating and Running HTTP Servers with NodeJS",
    "Asynchronous Programming in NodeJS: Callbacks, Promises, and Async/Await",
    "Building RESTful APIs with Express.js",
    "Handling Authentication and Authorization in NodeJS",
    "Integrating with Databases: MongoDB and MySQL",
    "Error Handling and Debugging in NodeJS",
    "Testing NodeJS Applications with Mocha and Chai",
    "Real-Time Applications with WebSockets and Socket.io",
    "Performance Optimization Techniques in NodeJS",
    "Deploying NodeJS Applications to Cloud Platforms",
    "Capstone Project: Building a Full-Stack Application with NodeJS",
    "Exam and Certification"
  ],
  "faq": [
    { "question": "Do I need prior experience with JavaScript or server-side programming?", "answer": "A basic understanding of JavaScript is recommended, but this course covers the essentials of NodeJS from scratch." },
    { "question": "How can I get certified?", "answer": "Complete the course and achieve at least 95% in the final exam to earn your certificate." },
    { "question": "What career opportunities can I pursue after this course?", "answer": "After completing this course, you can pursue roles such as NodeJS Developer, Backend Developer, Full-Stack Developer, or API Developer." }
  ],
  "instructor": {
    "name": "Mr. Ethan Roberts",
    "bio": "Mr. Ethan Roberts is a NodeJS and backend development expert with over 8 years of experience building scalable server-side applications. He has worked with top tech companies and has a passion for teaching developers how to build high-performance systems using NodeJS.",
    "image": "/images/instructor-nodejs.jpg" // Updated instructor image for NodeJS Certification Course
  },
  "reviews": [
    { "name": "Ravi", "rating": 5, "comment": "The course provided a great understanding of NodeJS. The projects were highly practical and helped me learn by doing." },
    { "name": "Meera", "rating": 4, "comment": "Excellent content. It would have been great to cover more on advanced performance optimization." }
  ],
  "testimonials": [
    { "name": "David James", "text": "This course helped me get a strong grasp on backend development. Now I can confidently build server-side applications with NodeJS." },
    { "name": "Emma Lee", "text": "Ethan’s teaching style made complex concepts in NodeJS easy to understand. The hands-on approach helped me apply what I learned." }
  ],
  "relatedCourses": [
    { "name": "Advanced NodeJS Development", "id": 12 },
    { "name": "Full-Stack Web Development with NodeJS and React", "id": 13 }
  ],
  "programoutcomes": [
    { "name": "Master backend development with NodeJS and Express.js", "id": 1 },
    { "name": "Gain practical experience in building RESTful APIs, working with databases, and deploying applications", "id": 2 }
  ]
},

// this for React Native Certification Course

{
  "id": 13,
  "name": "React Native Certification Course",
  "description": "This course teaches you how to build cross-platform mobile applications using React Native, a popular framework for building Android and iOS apps with JavaScript and React. Learn to work with native device features, create dynamic mobile UIs, and deploy your apps to app stores.",
  "price": "₹108 + GST",
  "category": "Mobile Development",
  "banner": ["react-native-course", "react-native-mobile"], // Multiple banner images for carousel
  "admissionStatus": "Open for Enrollment",
  "syllabus": [
    "Introduction to React Native: Understanding Mobile Development with JavaScript",
    "Setting Up the React Native Development Environment",
    "Working with React Native Components and Views",
    "Handling User Input with Forms and Text Inputs",
    "Navigating Between Screens with React Navigation",
    "Styling Mobile Applications in React Native",
    "State Management in React Native with Redux and Context API",
    "Integrating Native Device Features: Camera, GPS, and Push Notifications",
    "Handling Data and APIs in React Native Apps",
    "Debugging and Testing React Native Applications",
    "Building Performance-Optimized Mobile Apps with React Native",
    "Publishing Your App: Preparing for the Google Play Store and Apple App Store",
    "Capstone Project: Developing a Full Mobile Application with React Native",
    "Exam and Certification"
  ],
  "faq": [
    { "question": "Do I need prior mobile development experience?", "answer": "No, this course is designed for beginners and covers all the basics needed to get started with React Native." },
    { "question": "How can I get certified?", "answer": "Complete the course and achieve at least 95% in the final exam to earn your certificate." },
    { "question": "What job roles can I pursue after this course?", "answer": "After completing this course, you can pursue roles such as Mobile App Developer, React Native Developer, or Full-Stack Developer specializing in mobile apps." }
  ],
  "instructor": {
    "name": "Ms. Sophia Williams",
    "bio": "Ms. Sophia Williams is an expert in mobile app development with over 7 years of experience working with React Native and building cross-platform mobile applications. She has helped numerous developers build apps for both Android and iOS using React Native.",
    "image": "/images/instructor-react-native.jpg" // Updated instructor image for React Native Certification Course
  },
  "reviews": [
    { "name": "Nina", "rating": 5, "comment": "A fantastic course! I was able to build my first mobile app in just a few weeks. The instructor explained everything very clearly." },
    { "name": "Aaron", "rating": 4, "comment": "Great course with lots of practical exercises. I would have appreciated more content on integrating third-party libraries." }
  ],
  "testimonials": [
    { "name": "James Walker", "text": "Thanks to this course, I now have the skills to develop high-quality mobile applications. React Native is an amazing tool!" },
    { "name": "Ella Thompson", "text": "Sophia's approach to teaching React Native was clear and hands-on. I learned everything I needed to get started with mobile development." }
  ],
  "relatedCourses": [
    { "name": "Advanced React Native Development", "id": 13 },
    { "name": "Flutter Certification Course", "id": 14 }
  ],
  "programoutcomes": [
    { "name": "Learn to build cross-platform mobile applications using React Native", "id": 1 },
    { "name": "Gain experience in working with mobile-specific features like GPS, camera, and notifications", "id": 2 }
  ]
},

// this for AngularJS Certification Course

{
  "id": 14,
  "name": "AngularJS Certification Course",
  "description": "This course is designed to teach you the fundamentals and advanced concepts of AngularJS, a powerful JavaScript framework for building dynamic web applications. Learn how to develop single-page applications (SPAs), work with two-way data binding, and manage your app's architecture using AngularJS features.",
  "price": "₹108 + GST",
  "category": "Web Development",
  "banner": ["angularjs-course", "angularjs-web"], // Multiple banner images for carousel
  "admissionStatus": "Open for Enrollment",
  "syllabus": [
    "Introduction to AngularJS: Understanding the Framework and Its Ecosystem",
    "Setting Up the AngularJS Development Environment",
    "AngularJS Architecture: MVC and MVVM Patterns",
    "Creating and Managing AngularJS Modules and Controllers",
    "Data Binding in AngularJS: Two-Way Binding and Directives",
    "Working with AngularJS Services and Factories",
    "Routing in AngularJS: Building Single-Page Applications (SPA)",
    "Handling Forms and Validation in AngularJS",
    "Dependency Injection in AngularJS",
    "Directives and Filters: Extending AngularJS Functionality",
    "Working with RESTful APIs in AngularJS",
    "Unit Testing AngularJS Applications with Jasmine",
    "Performance Optimization Techniques in AngularJS",
    "Capstone Project: Building a Full-Featured AngularJS Application",
    "Exam and Certification"
  ],
  "faq": [
    { "question": "Do I need prior experience with JavaScript?", "answer": "Basic knowledge of JavaScript is recommended, but this course will teach you everything you need to know about AngularJS." },
    { "question": "How can I get certified?", "answer": "Complete the course and achieve at least 95% in the final exam to earn your certificate." },
    { "question": "What job opportunities can I pursue after this course?", "answer": "You can pursue roles such as AngularJS Developer, Front-End Developer, Web Developer, or Full-Stack Developer." }
  ],
  "instructor": {
    "name": "Mr. Robert Harrison",
    "bio": "Mr. Robert Harrison is an experienced AngularJS developer and instructor with over 10 years of experience in front-end web development. He has worked with major companies to build scalable and responsive applications and is passionate about teaching web development technologies.",
    "image": "/images/instructor-angularjs.jpg" // Updated instructor image for AngularJS Certification Course
  },
  "reviews": [
    { "name": "Priya", "rating": 5, "comment": "The course is comprehensive and helped me build a strong understanding of AngularJS. The hands-on projects were great!" },
    { "name": "John", "rating": 4, "comment": "Good course overall, but I would have liked more in-depth examples on dependency injection and testing." }
  ],
  "testimonials": [
    { "name": "Laura Smith", "text": "This course gave me the skills to build interactive SPAs with AngularJS. The concepts were explained clearly, and the projects were really helpful." },
    { "name": "Ethan Parker", "text": "Thanks to this course, I am now confident in using AngularJS for front-end development. Highly recommended for anyone serious about web development." }
  ],
  "relatedCourses": [
    { "name": "Advanced AngularJS Development", "id": 14 },
    { "name": "ReactJS Certification Course", "id": 10 }
  ],
  "programoutcomes": [
    { "name": "Learn to build dynamic single-page applications using AngularJS", "id": 1 },
    { "name": "Gain practical experience in data binding, services, and routing with AngularJS", "id": 2 }
  ]
},

// this is for TypeScript Certification Course

{
  "id": 15,
  "name": "TypeScript Certification Course",
  "description": "This course is designed to teach you TypeScript, a superset of JavaScript that brings static typing to the language. Learn how to leverage TypeScript’s powerful features like type annotations, interfaces, and classes to build more reliable and scalable applications.",
  "price": "₹108 + GST",
  "category": "Programming",
  "banner": ["typescript-course", "typescript-code"], // Multiple banner images for carousel
  "admissionStatus": "Open for Enrollment",
  "syllabus": [
    "Introduction to TypeScript: Understanding Static Typing and TypeScript Syntax",
    "Setting Up the TypeScript Development Environment",
    "Basic Types in TypeScript: Numbers, Strings, Arrays, and Tuples",
    "Working with Functions in TypeScript: Function Types and Optional Parameters",
    "TypeScript Classes and Interfaces: Building Object-Oriented Applications",
    "Advanced Types in TypeScript: Enums, Generics, and Union Types",
    "TypeScript Modules and Namespaces",
    "TypeScript and JavaScript Integration: Using TypeScript with Existing JavaScript Code",
    "Error Handling and Type Inference in TypeScript",
    "TypeScript and DOM Manipulation: Integrating with Web Applications",
    "Working with Third-Party Libraries and Frameworks in TypeScript",
    "Testing TypeScript Applications with Jasmine and Mocha",
    "Best Practices for Writing Scalable TypeScript Code",
    "Capstone Project: Building a TypeScript Application",
    "Exam and Certification"
  ],
  "faq": [
    { "question": "Do I need prior experience with JavaScript?", "answer": "Yes, a basic understanding of JavaScript is required as TypeScript is a superset of JavaScript." },
    { "question": "How can I get certified?", "answer": "Complete the course and achieve at least 95% in the final exam to earn your certificate." },
    { "question": "What job opportunities can I pursue after this course?", "answer": "After completing this course, you can pursue roles such as TypeScript Developer, JavaScript Developer, Front-End Developer, or Full-Stack Developer." }
  ],
  "instructor": {
    "name": "Mr. Daniel Harris",
    "bio": "Mr. Daniel Harris is a software engineer and TypeScript expert with over 8 years of experience. He has built enterprise-level applications using TypeScript and has a strong passion for teaching modern programming practices and scalable application development.",
    "image": "/images/instructor-typescript.jpg" // Updated instructor image for TypeScript Certification Course
  },
  "reviews": [
    { "name": "Anil", "rating": 5, "comment": "Great course for learning TypeScript! The instructor explained everything clearly, and the exercises were very helpful." },
    { "name": "Sophie", "rating": 4, "comment": "The course was solid, but I would have liked more advanced topics on generics and decorators." }
  ],
  "testimonials": [
    { "name": "Oliver Brown", "text": "This course helped me transition from JavaScript to TypeScript smoothly. The examples and projects were top-notch." },
    { "name": "Isabella Miller", "text": "Thanks to this course, I now feel confident in building TypeScript applications. The instructor was excellent!" }
  ],
  "relatedCourses": [
    { "name": "Advanced TypeScript Development", "id": 15 },
    { "name": "JavaScript Certification Course", "id": 9 }
  ],
  "programoutcomes": [
    { "name": "Master the fundamentals and advanced features of TypeScript", "id": 1 },
    { "name": "Gain experience in building scalable and reliable applications using TypeScript", "id": 2 }
  ]
},

// this for C programing 

{
  "id": 16,
  "name": "C Program Certification Course",
  "description": "This course provides a comprehensive introduction to C programming, one of the most fundamental and widely-used programming languages. Learn to write efficient and optimized code, understand memory management, and solve problems using C's powerful features.",
  "price": "₹108 + GST",
  "category": "Programming",
  "banner": ["c-program-course", "c-language"], // Multiple banner images for carousel
  "admissionStatus": "Open for Enrollment",
  "syllabus": [
    "Introduction to C Programming: History, Syntax, and Structure",
    "Data Types, Variables, and Constants in C",
    "Control Structures: If-Else, Switch, and Loops",
    "Functions in C: Defining and Calling Functions",
    "Arrays in C: One-Dimensional and Multi-Dimensional Arrays",
    "Pointers in C: Basics, Pointers and Arrays, and Memory Management",
    "Dynamic Memory Allocation in C: malloc, calloc, free",
    "Working with Strings and String Functions in C",
    "Structures and Unions in C",
    "File Handling in C: Reading and Writing Files",
    "Error Handling and Debugging Techniques in C",
    "Understanding Recursion in C",
    "Algorithms and Problem Solving in C",
    "Capstone Project: Building a Real-World Application in C",
    "Exam and Certification"
  ],
  "faq": [
    { "question": "Do I need prior programming experience?", "answer": "No, this course is designed for beginners. However, basic computer literacy will be helpful." },
    { "question": "How can I get certified?", "answer": "Complete the course and score at least 95% in the final exam to earn your certificate." },
    { "question": "What career opportunities can I pursue after this course?", "answer": "After completing this course, you can pursue roles such as C Programmer, Software Developer, System Programmer, or Embedded Systems Developer." }
  ],
  "instructor": {
    "name": "Mr. David Clark",
    "bio": "Mr. David Clark is an experienced C programmer with over 10 years of experience in system programming and embedded systems development. He has taught programming at various levels and is passionate about teaching the foundational concepts of C programming.",
    "image": "/images/instructor-c-program.jpg" // Updated instructor image for C Program Certification Course
  },
  "reviews": [
    { "name": "Arun", "rating": 5, "comment": "The course covered all the essential concepts of C programming. The projects helped solidify my understanding of the language." },
    { "name": "Nina", "rating": 4, "comment": "Great course! Would have appreciated more in-depth examples of dynamic memory allocation and pointers." }
  ],
  "testimonials": [
    { "name": "Alex Smith", "text": "This course gave me a strong foundation in C programming. I feel confident working with pointers and memory management now." },
    { "name": "Priya Patel", "text": "David's teaching style is very clear and easy to follow. The projects were very helpful in reinforcing the concepts." }
  ],
  "relatedCourses": [
    { "name": "Advanced C Programming", "id": 16 },
    { "name": "Data Structures and Algorithms in C", "id": 17 }
  ],
  "programoutcomes": [
    { "name": "Master C programming fundamentals and solve complex problems", "id": 1 },
    { "name": "Develop efficient and optimized code using C's powerful features", "id": 2 }
  ]
}









  
  
  
  
  
  

  //this is for basic python
  

];

function CourseDetails() {
  const { id } = useParams(); // Get the course ID from the route
  const course = courses.find((course) => course.id === parseInt(id)); // Find the course by ID

  if (!course) {
    return <p>Course not found!</p>;
  }

  return (
    <>
      <style>
        {`
          /* General Styling */
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          body {
            font-family: 'Arial', sans-serif;
            background-color: #f5f5f5;
            color: #333;
            margin: 0;
            padding: 0;
          }

          .course-details-page {
            max-width: 1200px;
            margin: auto;
            padding-top: 50px;
          }

          /* Hero Section */
          .hero-section {
            position: relative;
            height: 100vh;
            background-image: url(${course.banner[0]});
            background-size: cover;
            background-position: center;
            color: white;
            text-align: center;
            padding: 100px 20px;
            box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
            border-radius: 10px;
            overflow: hidden;
          }

          .hero-section h1 {
            font-size: 4rem;
            margin-bottom: 20px;
            text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.7);
            animation: fadeInUp 2s ease-out;
          }

          .hero-section p {
            font-size: 1.5rem;
            margin-bottom: 30px;
            font-weight: bold;
            text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
            animation: fadeInUp 2s ease-out;
            animation-delay: 0.5s;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(50px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .hero-section .button {
            background-color: #ff6600;
            padding: 15px 30px;
            color: white;
            font-size: 1.2rem;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }

          .hero-section .button:hover {
            background-color: #cc5200;
          }

          /* Course Details Cards */
          .details-section {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            margin-top: 40px;
          }

          .details-card {
            background-color: white;
            padding: 25px;
            width: 48%;
            border-radius: 8px;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .details-card:hover {
            transform: translateY(-10px);
            box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.15);
          }

          .details-card h2 {
            font-size: 1.6rem;
            margin-bottom: 15px;
            color: #007bff;
          }

          .details-card ul {
            list-style-type: none;
            padding: 0;
          }

          .details-card li {
            margin-bottom: 10px;
            font-size: 1.1rem;
            display: flex;
            align-items: center;
          }

          .details-card li svg {
            color: #007bff;
            margin-right: 10px;
          }

          .action-button {
            background-color: #ff6600;
            color: white;
            padding: 12px 30px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 1.1rem;
            transition: background 0.3s ease;
            margin-top: 20px;
          }

          .action-button:hover {
            background-color: #cc5200;
          }

          /* Aside Section */
          .aside-section {
            background-color: #fff;
            padding: 25px;
            width: 48%;
            border-radius: 8px;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
            margin-top: 40px;
          }

          .aside-section h3 {
            font-size: 1.6rem;
            color: #007bff;
            margin-bottom: 15px;
          }

          .aside-section ul {
            list-style-type: none;
            padding: 0;
            margin-bottom: 15px;
          }

          .aside-section li {
            margin-bottom: 10px;
            font-size: 1.1rem;
          }

          .aside-section button {
            background-color: #ff6600;
            color: white;
            padding: 12px 30px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 1.1rem;
            transition: background 0.3s ease;
            margin-top: 20px;
          }

          .aside-section button:hover {
            background-color: #cc5200;
          }

          /* Instructor Section */
          .instructor-section {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #f1f1f1;
            padding: 40px;
            border-radius: 10px;
            margin-top: 40px;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
          }

          .instructor-section img {
            border-radius: 50%;
            width: 150px;
            height: 150px;
            object-fit: cover;
            transition: transform 0.3s ease;
          }

          .instructor-section img:hover {
            transform: scale(1.1);
          }

          .instructor-info h2 {
            font-size: 2rem;
            color: #007bff;
            margin-bottom: 10px;
          }

          .instructor-info p {
            font-size: 1.1rem;
            color: #555;
            line-height: 1.5;
          }

          /* Reviews Section */
          .reviews-section {
            margin-top: 40px;
          }

          .reviews-section h3 {
            font-size: 1.8rem;
            color: #007bff;
            margin-bottom: 20px;
          }

          .reviews-section .review {
            background-color: white;
            padding: 20px;
            margin-bottom: 20px;
            border-radius: 8px;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
          }

          .reviews-section .review h4 {
            font-size: 1.2rem;
            color: #007bff;
          }

          .reviews-section .review p {
            font-size: 1rem;
            color: #555;
          }

          /* Footer Section */
          .footer {
            background-color: #333;
            color: white;
            padding: 40px 20px;
            text-align: center;
            margin-top: 60px;
          }

          .footer p {
            font-size: 1.1rem;
            margin-bottom: 10px;
          }

          .footer a {
            color: #ff6600;
            text-decoration: none;
          }
            /* Program Outcomes Section */
.program-outcomes-section {
  background: linear-gradient(to right, #007bff, #00d1b2); /* Attractive background gradient */
  padding: 40px 30px;
  margin-top: 60px;
  border-radius: 12px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center; /* Center the content horizontally */
  overflow: hidden;
}

.program-outcomes-header {
  position: relative;
  width: 100%;
  text-align: center;
  margin-bottom: 30px; /* Space between header and content */
}

.program-outcomes-header h3 {
  font-size: 2.5rem;
  color: #ffffff;
  font-weight: bold;
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.3);
  letter-spacing: 1px;
  margin: 0;
}

.program-outcomes-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px; /* Limit max width for better responsiveness */
  text-align: left; /* Ensure text is aligned to the left */
}

.program-outcomes-text {
  width: 55%;
  color: white;
}

.program-outcomes-text ul {
  list-style-type: none;
  padding: 0;
}

.program-outcomes-text li {
  font-size: 1.1rem;
  color: white;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  transition: transform 0.3s ease;
}

.program-outcomes-text li:hover {
  transform: translateX(10px);
}

.program-outcomes-text li svg {
  color: #ff6600;
  margin-right: 12px;
}

.program-outcomes-image {
  width: 40%;
}

.program-outcomes-image img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.program-outcomes-image img:hover {
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .program-outcomes-content {
    flex-direction: column;
    align-items: center;
  }

  .program-outcomes-text,
  .program-outcomes-image {
    width: 100%;
    margin-bottom: 20px;
  }

  .program-outcomes-header h3 {
    font-size: 2rem;
  }

  .program-outcomes-text li {
    font-size: 1rem;
  }
}


        `}
      </style>

      <div className="course-details-page">
        {/* Hero Section */}
        <div className="hero-section">
          <h1>{course.name}</h1>
          <p>{course.description}</p>
          <button className="button">Enroll Now</button>
        </div>

        <div className="details-section">
          <div className="details-card">
            <h2>About this Course</h2>
            <p>{course.description}</p>
            <ul>
              {course.syllabus.map((item, index) => (
                <li key={index}>
                  <FaCheckCircle /> {item}
                </li>
              ))}
            </ul>
            <button className="action-button">Enroll Now</button>
          </div>

          {/* Aside Section */}
          <div className="aside-section">
            <h3>Explore Our LMS Courses</h3>
            <p>Our LMS platform offers affordable and high-quality learning opportunities to boost your career! Here’s what you need to know about our course access and rewards:</p>
            <ul>
              <li><strong>Affordable Fee:</strong> Enroll in our courses for just ₹108 + GST.</li>
              <li><strong>Exclusive Offer:</strong> Achieve 95% or more in the exam, and you'll be eligible for an exclusive 65% discount on all courses.</li>
              <li><strong>Certification:</strong> Pass the test and earn a prestigious Certificate of Achievement, a testament to your hard work and knowledge.</li>
            </ul>
            <p>Don’t miss this opportunity to learn, excel, and save while enhancing your skills!</p>
            <button className="action-button">Get Mock Test</button>
          </div>
        </div>

        {/* Instructor Section */}
        <div className="details-card">
          <h2>Instructor</h2>
          <div className="instructor-section">
            <img src={course.instructor.image} alt={course.instructor.name} />
            <div className="instructor-info">
              <h2>{course.instructor.name}</h2>
              <p>{course.instructor.bio}</p>
            </div>
          </div>
        </div>

        {/* Reviews Section */}
        <div className="reviews-section">
          <h3>Student Reviews</h3>
          {course.reviews.map((review, index) => (
            <div className="review" key={index}>
              <h4>{review.name} - {review.rating} Stars</h4>
              <p>{review.comment}</p>
            </div>
          ))}
        </div>
  {/* Program Outcomes Section */}



<div className="program-outcomes-section">
  <div className="program-outcomes-header">
    <h3>Program Outcomes</h3>
  </div>
  <div className="program-outcomes-content">
    <div className="program-outcomes-text">
      <ul>
      {course.programoutcomes.map((item, index) => (
                <li key={index}>
                  <FaCheckCircle /> {item.name}
                </li>
              ))}
        {/* <li><FaCheckCircle /> Master Python syntax and core programming concepts.</li>
        <li><FaCheckCircle /> Learn to build and debug Python programs efficiently.</li>
        <li><FaCheckCircle /> Gain hands-on experience by working on real-world Python projects and applications.</li>
        <li><FaCheckCircle /> Develop skills in data analysis, web development, and automation using Python.</li>
        <li><FaCheckCircle /> Earn a certificate to showcase your Python programming expertise and enhance your career prospects.</li> */}
      </ul>
    </div>
    <div className="program-outcomes-image">
      <img src="/path-to-python-image.jpg" alt="Program Outcomes - Python" />
    </div>
  </div>
</div>





        {/* Footer Section */}
        <div className="footer">
          <p>&copy; 2024 Code All rights reserved.</p>
          <p>Learn. Excel. Succeed.</p>
          <p>Follow us on <a href="https://www.linkedin.com">LinkedIn</a>, <a href="https://twitter.com">Twitter</a>, and <a href="https://facebook.com">Facebook</a></p>
        </div>
      </div>
    </>
  );
}

export default CourseDetails;
